import { render } from "./ChooseDriver.vue?vue&type=template&id=348524ed&scoped=true"
import script from "./ChooseDriver.vue?vue&type=script&lang=js"
export * from "./ChooseDriver.vue?vue&type=script&lang=js"

import "./ChooseDriver.vue?vue&type=style&index=0&id=348524ed&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348524ed"]])

export default __exports__